import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { channelApiClient } from '@src/api/shared/community/channelApiClient';
import { useEffect, useState } from 'react';

export const useChannelsStatus = (code: string, shouldCheck: boolean = true) => {
  const [isExist, setIsExist] = useState<boolean>(false);

  useEffect(() => {
    if (!shouldCheck) {
      return;
    }

    const fetchStatus = async () => {
      try {
        const res = await channelApiClient.status(code);
        handleApiResponse(res, () => {
          setIsExist(true);
        });
      } catch (error) {
        console.error('Failed to fetch channel status:', error);
      }
    };
    fetchStatus();
  }, [code, shouldCheck]);

  return isExist;
};
